// Import React polyfill first to ensure it's available for all dependencies
import './utils/reactPolyfill.js';

import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import './index.css'
import 'leaflet/dist/leaflet.css'
import ErrorBoundary from './utils/ErrorBoundary.jsx'
import ProductionErrorBoundary from './components/ProductionErrorBoundary.jsx'
import { AuthProvider } from './contexts/AuthContext.jsx'
import { ThemeProvider } from './contexts/ThemeContext.jsx'

// Import schema generator to make it available globally
import './utils/schemaGenerator.js'

// Import and initialize environment verification
import { initEnvironmentVerification } from './utils/environmentVerifier.js'

// Verify environment variables early
initEnvironmentVerification();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ProductionErrorBoundary>
      <ErrorBoundary showDetails={true} onReset={() => window.location.reload()}>
        <BrowserRouter>
          <AuthProvider>
            <ThemeProvider>
              <App />
            </ThemeProvider>
          </AuthProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </ProductionErrorBoundary>
  </React.StrictMode>
)